<template>
    <v-layout
        row
    >
        <v-flex
        >
            <breadcrumbs
                v-if="user === 'superadmin' || user === 'admin'"
                :items="breadcrumbsItems"
            ></breadcrumbs>
            <v-card
                class="mx-auto"
                tile
                v-if="outlet.bg_image"
                max-height="400"
            >
                <v-img
                    v-if="outlet.logo"
                    :src="myLogo"
                    class="my-logo"
                    alt="logo"
                    max-height="100"
                    max-width="100"
                    style="margin-left: -50px;top: 50%;z-index: 200;position: absolute;left: 50%;"
                    contain
                />
                <v-img
                    class="white--text align-end"
                    :src="myBackground"
                    alt="background"
                    max-height="400"
                >
                    <v-card-text
                        :style="sloganStyle"
                    >
                        {{ outlet.slogan }}
                    </v-card-text>
                </v-img>
            </v-card>
            <div
                style="text-align: center"
            >
                <v-btn
                    :class="btnFontClass"
                    class="col-5 ma-4"
                    v-for="(queue, index) in queues"
                    :key="index"
                    x-large
                    :color="btnColor"
                    :style="btnTextSize(queue)"
                    @click="details(queue)"
                >
                    {{ queue.name }}
                </v-btn>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'outlet',
    props: ['outlet', 'queues', 'user'],
    data: () => ({
        breadcrumbsItems: '',
        breadcrumbsItems2: '',
    }),
    computed: {
        myBackground() {
            return '/storage' + this.outlet.bg_image;
        },
        myLogo() {
            return '/storage' + this.outlet.logo;
        },
        sloganStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: this.outlet.slogan_color ? this.outlet.slogan_color : '#000000'
            }
        },
        btnColor() {
            return this.outlet.main_color ? this.outlet.main_color : 'black';
        },
        btnFontClass() {
            let c = this.outlet.main_font_color ? this.outlet.main_font_color : 'white';
            return c + '--text'
        },
    },
    methods: {
        details(q) {
            window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id
        },
        monitor(q) {
            window.location.href = '/outlet/' + this.outlet.id + '/queue/' + q.id + '/appointment'
        },
        btnTextSize(q) {
            let size = 'small';
            if (q.name.length > 20 && q.name.length < 30) size = 'small';
            if (q.name.length > 30) size = 'x-small';
            if (window.innerWidth < 500) {
                size = '8px'
            }
            return {
                fontSize: size,
                fontWeight: 'bold',
            }
        },
    },
    beforeMount() {
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: false,
                href: '/outlet/' + this.outlet.id + '/edit',
                link: true,
                text: this.outlet.name,
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: this.outlet.name + ' Queue List',
            },
        ];
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/Outlet.vue